import { PrimaryMetroRegions } from '@cian/chats-api/lib/browser-entry';

import { TOfferGeo } from '../../types/offer';

export function isPrimaryMetroRegion(geo?: TOfferGeo): boolean {
  if (geo && geo.undergrounds && geo.undergrounds.length && geo.address && geo.address.length) {
    return Boolean(geo.address[0].id && PrimaryMetroRegions.includes(geo.address[0].id));
  }

  return Boolean(false);
}
